require('./referralsView.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
// @helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const language = getLanguage();
// @commons
const { OKCover } = require('commonsComponents/OKCover');
// @components
const OKRadioGroup = require('components/commons/OKRadioGroup/OKRadioGroup');
const OKRadioSwitch = require('components/commons/OKRadioSwitch/OKRadioSwitch');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const ReferralsPromotions = require('components/referralsPromotions/referralsPromotions');
const ReferralsInvitations = require('components/referralsInvitations/referralsInvitations');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @actions
const referralsActions = require('actions/referrals');
// @constants
const SELECTED_RADIO_PROMOTIONS = 'promotions';
const SELECTED_RADIO_INVITATIONS = 'invitations';

class ReferralsView extends React.Component {

    constructor(props) {
        super(props);

        this.handleRadioGroupChange = this.handleRadioGroupChange.bind(this);

        this.state = {
            selectedRadio: SELECTED_RADIO_PROMOTIONS
        }
    }

    componentDidMount() {
        this.props.referralsGetPromotionsList();
    }

    handleRadioGroupChange(value) {
        this.setState({
            selectedRadio: value
        })
    }

    buildRadioSwitch() {
        const { immReferrals } = this.props;

        return (
            <div className="referrals-view__radio-switch" >
                <OKRadioGroup
                    name="referralsPromoOptions"
                    onChange={value => this.handleRadioGroupChange(value)}
                    selectedValue={this.state.selectedRadio}
                >
                    <OKRadioSwitch
                        className="referrals-view__radio-switch-item"
                        value={SELECTED_RADIO_PROMOTIONS}
                    >
                        <FormattedText value="referrals-promos" />
                    </OKRadioSwitch>
                    <OKRadioSwitch
                        className="referrals-view__radio-switch-item"
                        disabled={!immReferrals.get('promotionsSuccess')}
                        value={SELECTED_RADIO_INVITATIONS}
                    >
                        <FormattedText value="referrals-referrals" />
                    </OKRadioSwitch>
                </OKRadioGroup>
            </div>
        );
    }

    buildContent() {
        const {
            immGlobalVariables,
            immReferrals,
            getGuardianInvitationInfo,
            referralsGetPromotionsList,
            resetFilter,
            setFilters,
            clearFilters
        } = this.props;
        const immMgmCMSNodes = immGlobalVariables.getIn(['variables', 'parameters', 'member_get_member_multi_promo', 'promotions']) || [];

        switch (this.state.selectedRadio) {
            case SELECTED_RADIO_PROMOTIONS:
                return (
                    <ReferralsPromotions
                        immMgmCMSNodes={immMgmCMSNodes}
                        immReferrals={immReferrals}
                        referralsGetPromotionsList={referralsGetPromotionsList}
                    />
                );
            case SELECTED_RADIO_INVITATIONS:
                return (
                    <ReferralsInvitations
                        immReferrals={immReferrals}
                        getGuardianInvitationInfo={getGuardianInvitationInfo}
                        resetFilter={resetFilter}
                        setFilters={setFilters}
                        clearFilters={clearFilters}
                    />
                );
        }
    }

    renderHeaderReferrals() {
        const { immReferrals } = this.props;
        let title;

        if (this.state.selectedRadio === SELECTED_RADIO_PROMOTIONS) {
            title = formatText('referrals-prizesForYouAndReferral');
        } else {
            if (immReferrals.get('referralsIsFetching')) {
                title = '';
            } else if (immReferrals.get('byOrder').size > 0) {
                title = formatText('referrals-invitationsSubtitle');
            } else {
                title = formatText('referrals-invitationsSubtitleEmpty');
            }
        }

        return (
            <p className="referrals-view__header-title">
                {title}
            </p>
        );
    }

    render() {
        const { immReferrals } = this.props;
        const radioSwitchContent = this.buildRadioSwitch();
        const content = this.buildContent();
        const headerReferrals = this.renderHeaderReferrals();
        const plainAmountObject = getPlainAmountObject(immReferrals.get('totalAmountEarned'));
        plainAmountObject.decimalsLength = 0;

        let amountEarnedContent;
        if (immReferrals.get('referralsSuccess')) {
            const totalAmountTitle = (
                <span className="referrals-view__total-amount-title">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                    />
                </span>
            );
            const totalAmountEarned = (
                <FormattedText
                    className="referrals-view__total-amount-subtitle"
                    value="referrals-totalAmountEarned"
                />
            );
            amountEarnedContent = (
                <div className="referrals-view__total-amount">
                    <div className="hidden-xs">
                        {totalAmountTitle}
                        {totalAmountEarned}
                    </div>
                    <div className="visible-xs">
                        {totalAmountEarned}
                        {totalAmountTitle}
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover
                            size="small"
                            section="mgm"
                            customClass="col-xs-12"
                        >
                            <OKHeaderLanding title={formatText('referrals-inviteFriend')}>
                                {amountEarnedContent}
                            </OKHeaderLanding>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <section className="referrals-view">
                            {headerReferrals}
                            {radioSwitchContent}
                            {content}
                        </section>
                    </div>
                </div>
            </div>
        );
    }
}

ReferralsView.propTypes = {
    immReferrals: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    referralsGetPromotionsList: PropTypes.func.isRequired,
    getGuardianInvitationInfo: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
};

module.exports.constructor = ReferralsView;
module.exports.ReferralsView = connect(
    state => ({
        immGlobalVariables: state.globalVariables,
        immReferrals: state.referrals
    }),
    {   referralsGetPromotionsList: referralsActions.referralsGetPromotionsList,
        getGuardianInvitationInfo: referralsActions.getGuardianInvitationInfo,
        resetFilter: referralsActions.resetReferralsInvitationsFilter,
        setFilters: referralsActions.setReferralsInvitationsFilters,
        clearFilters: referralsActions.clearReferralsInvitationsFilters,
    }
)(ReferralsView);
